import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useCms } from "../context/CmsContext";
import SocialMediaIcons from "./SocialMediaIcons";
import { homeContentDefaults } from "../cms/content/home.content";
import "../partyBossTheme.css";

const SECTION = "mx-auto max-w-6xl";

/**
 * Unified marketing footer (CMS-driven) — same layout as the former Home footer without logo.
 */
export default function SiteFooter() {
  const { cms } = useCms();
  const h = cms.home || {};
  const navigate = useNavigate();

  const waLink = useMemo(
    () => (text) =>
      `https://wa.me/${h.whatsappNumber || "917780291217"}?text=${encodeURIComponent(
        text || ""
      )}`,
    [h.whatsappNumber]
  );

  const footerSocial = useMemo(
    () => ({
      ...homeContentDefaults.socialLinks,
      ...(h.socialLinks || {}),
    }),
    [h.socialLinks]
  );

  const copyrightName = h.footer?.copyrightName || "Party Boss";

  return (
    <footer className="border-t border-white/15 bg-[#020105] px-[5%] py-12 lg:px-[8%]">
      <div className={SECTION}>
        <div className="mb-10 grid gap-10 border-b border-white/10 pb-10 md:grid-cols-2">
          <div>
            <p className="mb-3 font-black text-[#ffd166]">{h.footer?.title}</p>
            <p className="mb-4 text-sm text-[#c9c1d9]">{h.footer?.body}</p>
            <div className="flex flex-wrap gap-2">
              <button
                type="button"
                onClick={() => navigate("/booknow")}
                className="rounded-xl bg-gradient-to-r from-pink-500 to-violet-600 px-4 py-2 text-xs font-black text-white"
              >
                {h.footer?.bookLabel}
              </button>
              <a
                href={waLink(h.finalCta?.whatsappPreset || "Hi")}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-xl border border-white/20 px-4 py-2 text-xs font-bold text-white"
              >
                {h.footer?.whatsappLabel}
              </a>
            </div>
          </div>
          <div>
            <div className="mb-3 flex flex-wrap items-center gap-x-4 gap-y-2">
              <h3 className="m-0 text-base font-black tracking-wide text-[#ffd166] md:text-lg">
                Contact
              </h3>
              <span
                className="hidden h-10 w-px shrink-0 bg-gradient-to-b from-transparent via-white/25 to-transparent sm:block sm:self-stretch"
                aria-hidden
              />
              <SocialMediaIcons
                social={footerSocial}
                variant="footer"
                className="party-boss-social--footer-contact"
              />
            </div>
            <ul className="space-y-1.5 text-sm leading-relaxed text-[#c9c1d9]">
              {(h.footer?.contactLines || []).map((line, i) => (
                <li key={i}>{line}</li>
              ))}
            </ul>
          </div>
        </div>
        <p className="text-center text-xs text-white/45">
          © {new Date().getFullYear()} {copyrightName}. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}
